/* eslint-disable */
import React, { useContext, useState, useEffect } from 'react';
import styles from '../../MethodSlider.module.css';
import classNames from 'classnames';
import PaymentContext from '../../../../../../../../context/Payment/Context';
import Constants from '../../../../../../../../utils/Constants';

const { assetsURL } = Constants;
const SliderButton = ({data, index}) => {
  const paymentContext = useContext(PaymentContext);

  const {
    updateDashboard,
    dashboard
  } = paymentContext;

  const {icon, label, type} = data;
  const methodClasses = classNames({
      [styles.method]: true,
      [styles.activeMethod]: dashboard == type
  });

  useEffect(() => {
    updateDashboard('card')
  }, []);

  return (
   <div  className={methodClasses}  onClick={() => {
    updateDashboard(type)
    console.log(type);
    }}>
    <img width="24" height="24" className={dashboard == type?styles.redIcon:''} src={`${assetsURL}/svg/${icon}${dashboard == type?'-red':''}.svg`} alt={type} />
    <div>{label}</div>
   </div>
  );
};

export default SliderButton;
